import { toast } from 'react-toastify';

/**
 * Clears toast notifications.
 *
 * @param {string} [toastId] - Optional toast ID to dismiss a specific notification.
 *                             If omitted, all active toasts will be dismissed.
 */
export const clearNotifications = (toastId) => {
    if (toastId) {
        toast.dismiss(toastId);
    } else {
        toast.dismiss();
    }
};